<form #form="ngForm"
      novalidate="true"
      method="post"
      class="block">
    <p sizeClass="S: s2, !S: s1"
       *iCms="'title' of content; content: 'html'">
    </p>
    <p class="p2 col-11 m-t-1-s"
       *iCms="'subtitle' of content; skipEmpty: true"
       text>
    </p>

    @if (checkboxesMessage) {
    <p class="c1 col-12 m-t-2">
        *Please select at least one
    </p>
    }

    <input-wrap class="m-t-7 block">
        <checkbox name="newsletter_email"
                  (change)="onChange()"
                  style="padding-left: 28px !important;"
                  [(ngModel)]="newsletter">
            <span class="p2 block"
                  *iCms="'email_checkbox_copy' of content"
                  text>
            </span>
        </checkbox>
    </input-wrap>
    <input-wrap class="m-t-3 block">
        <checkbox name="newsletter_sms"
                  (change)="onChange()"
                  style="padding-left: 28px !important;"
                  [(ngModel)]="data.sms_optin">
            <span class="p2 block"
                  *iCms="'sms_checkbox_copy' of content"
                  text>
            </span>
        </checkbox>
    </input-wrap>
    @if (showBrochureCheckbox) {
    <input-wrap class="m-t-3 block">
        <checkbox name="newsletter_post"
                  (change)="onChange()"
                  style="padding-left: 28px !important;"
                  [(ngModel)]="data.post_optin">
            <span class="p2 block"
                  *iCms="'post_checkbox_copy' of content"
                  text>
            </span>
        </checkbox>
    </input-wrap>
    }
    <p class="c1 col-12 m-t-7"
       *iCms="'copy' of content; content: 'html'; skipEmpty: true">
    </p>
</form>